var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    [
      _c(
        "table",
        {
          staticClass: "default",
        },
        [
          _c(
            "caption",
            [_c("translate", [_vm._v("Öffentlich verlinkte Seiten")])],
            1
          ),
          _vm._v(" "),
          _c("thead", [
            _c("tr", [
              _c("th", [_c("translate", [_vm._v("Seite")])], 1),
              _vm._v(" "),
              _c("th", [_c("translate", [_vm._v("Link")])], 1),
              _vm._v(" "),
              _c("th", [_c("translate", [_vm._v("Passwort")])], 1),
              _vm._v(" "),
              _c("th", [_c("translate", [_vm._v("Ablaufdatum")])], 1),
              _vm._v(" "),
              _c(
                "th",
                {
                  staticClass: "actions",
                },
                [_c("translate", [_vm._v("Aktionen")])],
                1
              ),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "tbody",
            _vm._l(_vm.links, function (link) {
              return _c(
                "tr",
                {
                  key: link.id,
                },
                [
                  _c("td", [
                    _c(
                      "a",
                      {
                        attrs: {
                          href: _vm.getElementUrl(link),
                        },
                      },
                      [_vm._v(_vm._s(_vm.getPage(link)))]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _c(
                      "a",
                      {
                        attrs: {
                          href: _vm.getLinkUrl(link),
                          target: "_blank",
                          title: _vm.getLinkUrl(link),
                        },
                      },
                      [
                        _c("studip-icon", {
                          attrs: {
                            shape: "link-extern",
                            role: "clickable",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c("td", [_vm._v(_vm._s(link.attributes.password || "-"))]),
                  _vm._v(" "),
                  _c("td", [
                    _vm._v(
                      _vm._s(
                        _vm.getReadableDate(link.attributes["expire-date"])
                      )
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "td",
                    {
                      staticClass: "actions",
                    },
                    [
                      _c("studip-action-menu", {
                        attrs: {
                          items: _vm.menuItems,
                        },
                        on: {
                          editLink: function editLink($event) {
                            return _vm.editLink(link)
                          },
                          deleteLink: function deleteLink($event) {
                            return _vm.displayDeleteLink(link)
                          },
                          copyLinkToClipboard: function copyLinkToClipboard(
                            $event
                          ) {
                            return _vm.copyLinkToClipboard(link)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ]
              )
            }),
            0
          ),
        ]
      ),
      _vm._v(" "),
      _vm.showDeleteDialog
        ? _c("studip-dialog", {
            attrs: {
              title: _vm.$gettext("Link löschen"),
              question: _vm.$gettext("Möchten Sie diesen Link löschen"),
              height: "180",
              width: "360",
            },
            on: {
              confirm: _vm.executeDelete,
              close: _vm.closeDeleteDialog,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showEditDialog
        ? _c("studip-dialog", {
            attrs: {
              title: _vm.$gettext("Link bearbeiten"),
              confirmText: _vm.$gettext("Speichern"),
              confirmClass: "accept",
              closeText: _vm.$gettext("Schließen"),
              closeClass: "cancel",
            },
            on: {
              close: _vm.closeEditDialog,
              confirm: _vm.storeLink,
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "dialogContent",
                  fn: function fn() {
                    return [
                      _c(
                        "form",
                        {
                          staticClass: "default",
                          on: {
                            submit: function submit($event) {
                              $event.preventDefault()
                            },
                          },
                        },
                        [
                          _c(
                            "label",
                            [
                              _c("translate", [_vm._v("Passwort")]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.currentLink.attributes.password,
                                    expression:
                                      "currentLink.attributes.password",
                                  },
                                ],
                                attrs: {
                                  type: "text",
                                },
                                domProps: {
                                  value: _vm.currentLink.attributes.password,
                                },
                                on: {
                                  input: function input($event) {
                                    if ($event.target.composing) return
                                    _vm.$set(
                                      _vm.currentLink.attributes,
                                      "password",
                                      $event.target.value
                                    )
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "label",
                            [
                              _c("translate", [_vm._v("Ablaufdatum")]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value:
                                      _vm.currentLink.attributes["expire-date"],
                                    expression:
                                      "currentLink.attributes['expire-date']",
                                  },
                                ],
                                staticClass: "size-l",
                                attrs: {
                                  type: "date",
                                },
                                domProps: {
                                  value:
                                    _vm.currentLink.attributes["expire-date"],
                                },
                                on: {
                                  input: function input($event) {
                                    if ($event.target.composing) return
                                    _vm.$set(
                                      _vm.currentLink.attributes,
                                      "expire-date",
                                      $event.target.value
                                    )
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      ),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              false,
              1044277093
            ),
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }